"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Networker Open API
 * # Authentication  Add header `Authorization: Bearer {YOUR BEARER TOKEN}` to those authenticated requests.
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchApi = exports.SearchApiFactory = exports.SearchApiFp = exports.SearchApiAxiosParamCreator = exports.ProfileApi = exports.ProfileApiFactory = exports.ProfileApiFp = exports.ProfileApiAxiosParamCreator = exports.PlatformApi = exports.PlatformApiFactory = exports.PlatformApiFp = exports.PlatformApiAxiosParamCreator = exports.EntityUnitApi = exports.EntityUnitApiFactory = exports.EntityUnitApiFp = exports.EntityUnitApiAxiosParamCreator = exports.CollectionApi = exports.CollectionApiFactory = exports.CollectionApiFp = exports.CollectionApiAxiosParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiAxiosParamCreator = exports.SearchDtoStatusEnum = exports.JsonNodeNodeTypeEnum = exports.CollectionUpdatedRequestLevelEnum = exports.CollectionDtoLevelEnum = exports.ApiErrorCode = exports.ApiErrorStatusEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var ApiErrorStatusEnum;
(function (ApiErrorStatusEnum) {
    ApiErrorStatusEnum["_100Continue"] = "100 CONTINUE";
    ApiErrorStatusEnum["_101SwitchingProtocols"] = "101 SWITCHING_PROTOCOLS";
    ApiErrorStatusEnum["_102Processing"] = "102 PROCESSING";
    ApiErrorStatusEnum["_103Checkpoint"] = "103 CHECKPOINT";
    ApiErrorStatusEnum["_200Ok"] = "200 OK";
    ApiErrorStatusEnum["_201Created"] = "201 CREATED";
    ApiErrorStatusEnum["_202Accepted"] = "202 ACCEPTED";
    ApiErrorStatusEnum["_203NonAuthoritativeInformation"] = "203 NON_AUTHORITATIVE_INFORMATION";
    ApiErrorStatusEnum["_204NoContent"] = "204 NO_CONTENT";
    ApiErrorStatusEnum["_205ResetContent"] = "205 RESET_CONTENT";
    ApiErrorStatusEnum["_206PartialContent"] = "206 PARTIAL_CONTENT";
    ApiErrorStatusEnum["_207MultiStatus"] = "207 MULTI_STATUS";
    ApiErrorStatusEnum["_208AlreadyReported"] = "208 ALREADY_REPORTED";
    ApiErrorStatusEnum["_226ImUsed"] = "226 IM_USED";
    ApiErrorStatusEnum["_300MultipleChoices"] = "300 MULTIPLE_CHOICES";
    ApiErrorStatusEnum["_301MovedPermanently"] = "301 MOVED_PERMANENTLY";
    ApiErrorStatusEnum["_302Found"] = "302 FOUND";
    ApiErrorStatusEnum["_302MovedTemporarily"] = "302 MOVED_TEMPORARILY";
    ApiErrorStatusEnum["_303SeeOther"] = "303 SEE_OTHER";
    ApiErrorStatusEnum["_304NotModified"] = "304 NOT_MODIFIED";
    ApiErrorStatusEnum["_305UseProxy"] = "305 USE_PROXY";
    ApiErrorStatusEnum["_307TemporaryRedirect"] = "307 TEMPORARY_REDIRECT";
    ApiErrorStatusEnum["_308PermanentRedirect"] = "308 PERMANENT_REDIRECT";
    ApiErrorStatusEnum["_400BadRequest"] = "400 BAD_REQUEST";
    ApiErrorStatusEnum["_401Unauthorized"] = "401 UNAUTHORIZED";
    ApiErrorStatusEnum["_402PaymentRequired"] = "402 PAYMENT_REQUIRED";
    ApiErrorStatusEnum["_403Forbidden"] = "403 FORBIDDEN";
    ApiErrorStatusEnum["_404NotFound"] = "404 NOT_FOUND";
    ApiErrorStatusEnum["_405MethodNotAllowed"] = "405 METHOD_NOT_ALLOWED";
    ApiErrorStatusEnum["_406NotAcceptable"] = "406 NOT_ACCEPTABLE";
    ApiErrorStatusEnum["_407ProxyAuthenticationRequired"] = "407 PROXY_AUTHENTICATION_REQUIRED";
    ApiErrorStatusEnum["_408RequestTimeout"] = "408 REQUEST_TIMEOUT";
    ApiErrorStatusEnum["_409Conflict"] = "409 CONFLICT";
    ApiErrorStatusEnum["_410Gone"] = "410 GONE";
    ApiErrorStatusEnum["_411LengthRequired"] = "411 LENGTH_REQUIRED";
    ApiErrorStatusEnum["_412PreconditionFailed"] = "412 PRECONDITION_FAILED";
    ApiErrorStatusEnum["_413PayloadTooLarge"] = "413 PAYLOAD_TOO_LARGE";
    ApiErrorStatusEnum["_413RequestEntityTooLarge"] = "413 REQUEST_ENTITY_TOO_LARGE";
    ApiErrorStatusEnum["_414UriTooLong"] = "414 URI_TOO_LONG";
    ApiErrorStatusEnum["_414RequestUriTooLong"] = "414 REQUEST_URI_TOO_LONG";
    ApiErrorStatusEnum["_415UnsupportedMediaType"] = "415 UNSUPPORTED_MEDIA_TYPE";
    ApiErrorStatusEnum["_416RequestedRangeNotSatisfiable"] = "416 REQUESTED_RANGE_NOT_SATISFIABLE";
    ApiErrorStatusEnum["_417ExpectationFailed"] = "417 EXPECTATION_FAILED";
    ApiErrorStatusEnum["_418IAmATeapot"] = "418 I_AM_A_TEAPOT";
    ApiErrorStatusEnum["_419InsufficientSpaceOnResource"] = "419 INSUFFICIENT_SPACE_ON_RESOURCE";
    ApiErrorStatusEnum["_420MethodFailure"] = "420 METHOD_FAILURE";
    ApiErrorStatusEnum["_421DestinationLocked"] = "421 DESTINATION_LOCKED";
    ApiErrorStatusEnum["_422UnprocessableEntity"] = "422 UNPROCESSABLE_ENTITY";
    ApiErrorStatusEnum["_423Locked"] = "423 LOCKED";
    ApiErrorStatusEnum["_424FailedDependency"] = "424 FAILED_DEPENDENCY";
    ApiErrorStatusEnum["_425TooEarly"] = "425 TOO_EARLY";
    ApiErrorStatusEnum["_426UpgradeRequired"] = "426 UPGRADE_REQUIRED";
    ApiErrorStatusEnum["_428PreconditionRequired"] = "428 PRECONDITION_REQUIRED";
    ApiErrorStatusEnum["_429TooManyRequests"] = "429 TOO_MANY_REQUESTS";
    ApiErrorStatusEnum["_431RequestHeaderFieldsTooLarge"] = "431 REQUEST_HEADER_FIELDS_TOO_LARGE";
    ApiErrorStatusEnum["_451UnavailableForLegalReasons"] = "451 UNAVAILABLE_FOR_LEGAL_REASONS";
    ApiErrorStatusEnum["_500InternalServerError"] = "500 INTERNAL_SERVER_ERROR";
    ApiErrorStatusEnum["_501NotImplemented"] = "501 NOT_IMPLEMENTED";
    ApiErrorStatusEnum["_502BadGateway"] = "502 BAD_GATEWAY";
    ApiErrorStatusEnum["_503ServiceUnavailable"] = "503 SERVICE_UNAVAILABLE";
    ApiErrorStatusEnum["_504GatewayTimeout"] = "504 GATEWAY_TIMEOUT";
    ApiErrorStatusEnum["_505HttpVersionNotSupported"] = "505 HTTP_VERSION_NOT_SUPPORTED";
    ApiErrorStatusEnum["_506VariantAlsoNegotiates"] = "506 VARIANT_ALSO_NEGOTIATES";
    ApiErrorStatusEnum["_507InsufficientStorage"] = "507 INSUFFICIENT_STORAGE";
    ApiErrorStatusEnum["_508LoopDetected"] = "508 LOOP_DETECTED";
    ApiErrorStatusEnum["_509BandwidthLimitExceeded"] = "509 BANDWIDTH_LIMIT_EXCEEDED";
    ApiErrorStatusEnum["_510NotExtended"] = "510 NOT_EXTENDED";
    ApiErrorStatusEnum["_511NetworkAuthenticationRequired"] = "511 NETWORK_AUTHENTICATION_REQUIRED";
})(ApiErrorStatusEnum = exports.ApiErrorStatusEnum || (exports.ApiErrorStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApiErrorCode;
(function (ApiErrorCode) {
    ApiErrorCode["Forbidden"] = "FORBIDDEN";
    ApiErrorCode["Unauthorized"] = "UNAUTHORIZED";
    ApiErrorCode["UnexpectedError"] = "UNEXPECTED_ERROR";
    ApiErrorCode["InvalidBlobContentType"] = "INVALID_BLOB_CONTENT_TYPE";
    ApiErrorCode["UserNotFound"] = "USER_NOT_FOUND";
    ApiErrorCode["SearchNotFound"] = "SEARCH_NOT_FOUND";
    ApiErrorCode["AssistantIsReplying"] = "ASSISTANT_IS_REPLYING";
    ApiErrorCode["OpenaiApiError"] = "OPENAI_API_ERROR";
    ApiErrorCode["OpenaiSseApiError"] = "OPENAI_SSE_API_ERROR";
    ApiErrorCode["ConditionNotFound"] = "CONDITION_NOT_FOUND";
    ApiErrorCode["CollectionNotFound"] = "COLLECTION_NOT_FOUND";
    ApiErrorCode["TemplateFail"] = "TEMPLATE_FAIL";
})(ApiErrorCode = exports.ApiErrorCode || (exports.ApiErrorCode = {}));
/**
    * @export
    * @enum {string}
    */
var CollectionDtoLevelEnum;
(function (CollectionDtoLevelEnum) {
    CollectionDtoLevelEnum["_0"] = "LEVEL_0";
    CollectionDtoLevelEnum["_1"] = "LEVEL_1";
    CollectionDtoLevelEnum["_2"] = "LEVEL_2";
    CollectionDtoLevelEnum["_3"] = "LEVEL_3";
    CollectionDtoLevelEnum["_4"] = "LEVEL_4";
    CollectionDtoLevelEnum["_5"] = "LEVEL_5";
})(CollectionDtoLevelEnum = exports.CollectionDtoLevelEnum || (exports.CollectionDtoLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CollectionUpdatedRequestLevelEnum;
(function (CollectionUpdatedRequestLevelEnum) {
    CollectionUpdatedRequestLevelEnum["_0"] = "LEVEL_0";
    CollectionUpdatedRequestLevelEnum["_1"] = "LEVEL_1";
    CollectionUpdatedRequestLevelEnum["_2"] = "LEVEL_2";
    CollectionUpdatedRequestLevelEnum["_3"] = "LEVEL_3";
    CollectionUpdatedRequestLevelEnum["_4"] = "LEVEL_4";
    CollectionUpdatedRequestLevelEnum["_5"] = "LEVEL_5";
})(CollectionUpdatedRequestLevelEnum = exports.CollectionUpdatedRequestLevelEnum || (exports.CollectionUpdatedRequestLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var JsonNodeNodeTypeEnum;
(function (JsonNodeNodeTypeEnum) {
    JsonNodeNodeTypeEnum["Array"] = "ARRAY";
    JsonNodeNodeTypeEnum["Binary"] = "BINARY";
    JsonNodeNodeTypeEnum["Boolean"] = "BOOLEAN";
    JsonNodeNodeTypeEnum["Missing"] = "MISSING";
    JsonNodeNodeTypeEnum["Null"] = "NULL";
    JsonNodeNodeTypeEnum["Number"] = "NUMBER";
    JsonNodeNodeTypeEnum["Object"] = "OBJECT";
    JsonNodeNodeTypeEnum["Pojo"] = "POJO";
    JsonNodeNodeTypeEnum["String"] = "STRING";
})(JsonNodeNodeTypeEnum = exports.JsonNodeNodeTypeEnum || (exports.JsonNodeNodeTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SearchDtoStatusEnum;
(function (SearchDtoStatusEnum) {
    SearchDtoStatusEnum["Processing"] = "PROCESSING";
    SearchDtoStatusEnum["Finished"] = "FINISHED";
    SearchDtoStatusEnum["Failed"] = "FAILED";
    SearchDtoStatusEnum["SseProcessing"] = "SSE_PROCESSING";
    SearchDtoStatusEnum["SseFailed"] = "SSE_FAILED";
    SearchDtoStatusEnum["SseError"] = "SSE_ERROR";
})(SearchDtoStatusEnum = exports.SearchDtoStatusEnum || (exports.SearchDtoStatusEnum = {}));
/**
 * AuthApi - axios parameter creator
 * @export
 */
exports.AuthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/auth/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
exports.AuthApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AuthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMe(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
exports.AuthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AuthApiFp(configuration);
    return {
        /**
         *
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: function (options) {
            return localVarFp.getMe(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
var AuthApi = /** @class */ (function (_super) {
    __extends(AuthApi, _super);
    function AuthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.getMe = function (options) {
        var _this = this;
        return exports.AuthApiFp(this.configuration).getMe(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthApi;
}(base_1.BaseAPI));
exports.AuthApi = AuthApi;
/**
 * CollectionApi - axios parameter creator
 * @export
 */
exports.CollectionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 刪除收藏清單
         * @param {string} userId
         * @param {string} unitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollection: function (userId, unitId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('deleteCollection', 'userId', userId);
                            // verify required parameter 'unitId' is not null or undefined
                            common_1.assertParamExists('deleteCollection', 'unitId', unitId);
                            localVarPath = "/api/user/{userId}/collection"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (unitId !== undefined) {
                                localVarQueryParameter['unitId'] = unitId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary 取得收藏清單
         * @param {string} userId
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection: function (userId, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('getCollection', 'userId', userId);
                            localVarPath = "/api/user/{userId}/collection"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary 儲存搜尋結果
         * @param {string} userId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveResults: function (userId, requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('saveResults', 'userId', userId);
                            // verify required parameter 'requestBody' is not null or undefined
                            common_1.assertParamExists('saveResults', 'requestBody', requestBody);
                            localVarPath = "/api/user/{userId}/collection/save"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新收藏清單
         * @param {string} userId
         * @param {string} unitId
         * @param {CollectionUpdatedRequest} collectionUpdatedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollection: function (userId, unitId, collectionUpdatedRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('updateCollection', 'userId', userId);
                            // verify required parameter 'unitId' is not null or undefined
                            common_1.assertParamExists('updateCollection', 'unitId', unitId);
                            // verify required parameter 'collectionUpdatedRequest' is not null or undefined
                            common_1.assertParamExists('updateCollection', 'collectionUpdatedRequest', collectionUpdatedRequest);
                            localVarPath = "/api/user/{userId}/collection"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (unitId !== undefined) {
                                localVarQueryParameter['unitId'] = unitId;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(collectionUpdatedRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CollectionApi - functional programming interface
 * @export
 */
exports.CollectionApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.CollectionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary 刪除收藏清單
         * @param {string} userId
         * @param {string} unitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollection: function (userId, unitId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCollection(userId, unitId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 取得收藏清單
         * @param {string} userId
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection: function (userId, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCollection(userId, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 儲存搜尋結果
         * @param {string} userId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveResults: function (userId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveResults(userId, requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新收藏清單
         * @param {string} userId
         * @param {string} unitId
         * @param {CollectionUpdatedRequest} collectionUpdatedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollection: function (userId, unitId, collectionUpdatedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCollection(userId, unitId, collectionUpdatedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * CollectionApi - factory interface
 * @export
 */
exports.CollectionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.CollectionApiFp(configuration);
    return {
        /**
         *
         * @summary 刪除收藏清單
         * @param {string} userId
         * @param {string} unitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollection: function (userId, unitId, options) {
            return localVarFp.deleteCollection(userId, unitId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 取得收藏清單
         * @param {string} userId
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection: function (userId, page, size, options) {
            return localVarFp.getCollection(userId, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 儲存搜尋結果
         * @param {string} userId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveResults: function (userId, requestBody, options) {
            return localVarFp.saveResults(userId, requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新收藏清單
         * @param {string} userId
         * @param {string} unitId
         * @param {CollectionUpdatedRequest} collectionUpdatedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollection: function (userId, unitId, collectionUpdatedRequest, options) {
            return localVarFp.updateCollection(userId, unitId, collectionUpdatedRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CollectionApi - object-oriented interface
 * @export
 * @class CollectionApi
 * @extends {BaseAPI}
 */
var CollectionApi = /** @class */ (function (_super) {
    __extends(CollectionApi, _super);
    function CollectionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 刪除收藏清單
     * @param {string} userId
     * @param {string} unitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionApi
     */
    CollectionApi.prototype.deleteCollection = function (userId, unitId, options) {
        var _this = this;
        return exports.CollectionApiFp(this.configuration).deleteCollection(userId, unitId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 取得收藏清單
     * @param {string} userId
     * @param {number} [page]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionApi
     */
    CollectionApi.prototype.getCollection = function (userId, page, size, options) {
        var _this = this;
        return exports.CollectionApiFp(this.configuration).getCollection(userId, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 儲存搜尋結果
     * @param {string} userId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionApi
     */
    CollectionApi.prototype.saveResults = function (userId, requestBody, options) {
        var _this = this;
        return exports.CollectionApiFp(this.configuration).saveResults(userId, requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新收藏清單
     * @param {string} userId
     * @param {string} unitId
     * @param {CollectionUpdatedRequest} collectionUpdatedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionApi
     */
    CollectionApi.prototype.updateCollection = function (userId, unitId, collectionUpdatedRequest, options) {
        var _this = this;
        return exports.CollectionApiFp(this.configuration).updateCollection(userId, unitId, collectionUpdatedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CollectionApi;
}(base_1.BaseAPI));
exports.CollectionApi = CollectionApi;
/**
 * EntityUnitApi - axios parameter creator
 * @export
 */
exports.EntityUnitApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 查詢 Unit 詳細資料
         * @param {string} userId
         * @param {string} unitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitDetail: function (userId, unitId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('getUnitDetail', 'userId', userId);
                            // verify required parameter 'unitId' is not null or undefined
                            common_1.assertParamExists('getUnitDetail', 'unitId', unitId);
                            localVarPath = "/api/user/{userId}/unit/{unitId}"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)))
                                .replace("{" + "unitId" + "}", encodeURIComponent(String(unitId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * EntityUnitApi - functional programming interface
 * @export
 */
exports.EntityUnitApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.EntityUnitApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary 查詢 Unit 詳細資料
         * @param {string} userId
         * @param {string} unitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitDetail: function (userId, unitId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUnitDetail(userId, unitId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * EntityUnitApi - factory interface
 * @export
 */
exports.EntityUnitApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.EntityUnitApiFp(configuration);
    return {
        /**
         *
         * @summary 查詢 Unit 詳細資料
         * @param {string} userId
         * @param {string} unitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitDetail: function (userId, unitId, options) {
            return localVarFp.getUnitDetail(userId, unitId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * EntityUnitApi - object-oriented interface
 * @export
 * @class EntityUnitApi
 * @extends {BaseAPI}
 */
var EntityUnitApi = /** @class */ (function (_super) {
    __extends(EntityUnitApi, _super);
    function EntityUnitApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 查詢 Unit 詳細資料
     * @param {string} userId
     * @param {string} unitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityUnitApi
     */
    EntityUnitApi.prototype.getUnitDetail = function (userId, unitId, options) {
        var _this = this;
        return exports.EntityUnitApiFp(this.configuration).getUnitDetail(userId, unitId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EntityUnitApi;
}(base_1.BaseAPI));
exports.EntityUnitApi = EntityUnitApi;
/**
 * PlatformApi - axios parameter creator
 * @export
 */
exports.PlatformApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 取得搜尋條件過濾清單
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterList: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/platform/filter-items";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * PlatformApi - functional programming interface
 * @export
 */
exports.PlatformApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.PlatformApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary 取得搜尋條件過濾清單
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterList: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFilterList(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * PlatformApi - factory interface
 * @export
 */
exports.PlatformApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.PlatformApiFp(configuration);
    return {
        /**
         *
         * @summary 取得搜尋條件過濾清單
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterList: function (options) {
            return localVarFp.getFilterList(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * PlatformApi - object-oriented interface
 * @export
 * @class PlatformApi
 * @extends {BaseAPI}
 */
var PlatformApi = /** @class */ (function (_super) {
    __extends(PlatformApi, _super);
    function PlatformApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 取得搜尋條件過濾清單
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    PlatformApi.prototype.getFilterList = function (options) {
        var _this = this;
        return exports.PlatformApiFp(this.configuration).getFilterList(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PlatformApi;
}(base_1.BaseAPI));
exports.PlatformApi = PlatformApi;
/**
 * ProfileApi - axios parameter creator
 * @export
 */
exports.ProfileApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get user profile
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: function (userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('getProfile', 'userId', userId);
                            localVarPath = "/api/user/{userId}/profile"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Edit user privacy agreement
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        togglePrivacy: function (userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('togglePrivacy', 'userId', userId);
                            localVarPath = "/api/user/{userId}/profile/privacy"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Edit user profile
         * @param {string} userId
         * @param {ProfileUpdatedRequest} profileUpdatedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: function (userId, profileUpdatedRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('updateProfile', 'userId', userId);
                            // verify required parameter 'profileUpdatedRequest' is not null or undefined
                            common_1.assertParamExists('updateProfile', 'profileUpdatedRequest', profileUpdatedRequest);
                            localVarPath = "/api/user/{userId}/profile"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(profileUpdatedRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ProfileApi - functional programming interface
 * @export
 */
exports.ProfileApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ProfileApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get user profile
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: function (userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProfile(userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Edit user privacy agreement
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        togglePrivacy: function (userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.togglePrivacy(userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Edit user profile
         * @param {string} userId
         * @param {ProfileUpdatedRequest} profileUpdatedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: function (userId, profileUpdatedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProfile(userId, profileUpdatedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ProfileApi - factory interface
 * @export
 */
exports.ProfileApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ProfileApiFp(configuration);
    return {
        /**
         *
         * @summary Get user profile
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: function (userId, options) {
            return localVarFp.getProfile(userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Edit user privacy agreement
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        togglePrivacy: function (userId, options) {
            return localVarFp.togglePrivacy(userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Edit user profile
         * @param {string} userId
         * @param {ProfileUpdatedRequest} profileUpdatedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: function (userId, profileUpdatedRequest, options) {
            return localVarFp.updateProfile(userId, profileUpdatedRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
var ProfileApi = /** @class */ (function (_super) {
    __extends(ProfileApi, _super);
    function ProfileApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get user profile
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.getProfile = function (userId, options) {
        var _this = this;
        return exports.ProfileApiFp(this.configuration).getProfile(userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Edit user privacy agreement
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.togglePrivacy = function (userId, options) {
        var _this = this;
        return exports.ProfileApiFp(this.configuration).togglePrivacy(userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Edit user profile
     * @param {string} userId
     * @param {ProfileUpdatedRequest} profileUpdatedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    ProfileApi.prototype.updateProfile = function (userId, profileUpdatedRequest, options) {
        var _this = this;
        return exports.ProfileApiFp(this.configuration).updateProfile(userId, profileUpdatedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProfileApi;
}(base_1.BaseAPI));
exports.ProfileApi = ProfileApi;
/**
 * SearchApi - axios parameter creator
 * @export
 */
exports.SearchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 建立新搜尋(對話)
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewChat: function (userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('createNewChat', 'userId', userId);
                            localVarPath = "/api/user/{userId}/search"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary 取得單一搜尋(對話)
         * @param {string} userId
         * @param {string} searchId
         * @param {QueryChatDetailRequest} [queryChatDetailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDetail: function (userId, searchId, queryChatDetailRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('getChatDetail', 'userId', userId);
                            // verify required parameter 'searchId' is not null or undefined
                            common_1.assertParamExists('getChatDetail', 'searchId', searchId);
                            localVarPath = "/api/user/{userId}/search/{searchId}/history/detail"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)))
                                .replace("{" + "searchId" + "}", encodeURIComponent(String(searchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(queryChatDetailRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary 取得搜尋紀錄清單(對話列表)
         * @param {string} userId
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatList: function (userId, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('getChatList', 'userId', userId);
                            localVarPath = "/api/user/{userId}/search/histories"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary 中斷AI對話
         * @param {string} userId
         * @param {string} searchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interruptChat: function (userId, searchId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('interruptChat', 'userId', userId);
                            // verify required parameter 'searchId' is not null or undefined
                            common_1.assertParamExists('interruptChat', 'searchId', searchId);
                            localVarPath = "/api/user/{userId}/search/{searchId}/message/interrupt"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)))
                                .replace("{" + "searchId" + "}", encodeURIComponent(String(searchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary 發送新訊息
         * @param {string} userId
         * @param {string} searchId
         * @param {SendMessageRequest} sendMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: function (userId, searchId, sendMessageRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('sendMessage', 'userId', userId);
                            // verify required parameter 'searchId' is not null or undefined
                            common_1.assertParamExists('sendMessage', 'searchId', searchId);
                            // verify required parameter 'sendMessageRequest' is not null or undefined
                            common_1.assertParamExists('sendMessage', 'sendMessageRequest', sendMessageRequest);
                            localVarPath = "/api/user/{userId}/search/{searchId}/message"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)))
                                .replace("{" + "searchId" + "}", encodeURIComponent(String(searchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(sendMessageRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary 發送新訊息(SSE)
         * @param {string} userId
         * @param {string} searchId
         * @param {SendMessageRequest} sendMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageSSE: function (userId, searchId, sendMessageRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('sendMessageSSE', 'userId', userId);
                            // verify required parameter 'searchId' is not null or undefined
                            common_1.assertParamExists('sendMessageSSE', 'searchId', searchId);
                            // verify required parameter 'sendMessageRequest' is not null or undefined
                            common_1.assertParamExists('sendMessageSSE', 'sendMessageRequest', sendMessageRequest);
                            localVarPath = "/api/user/{userId}/search/{searchId}/message"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)))
                                .replace("{" + "searchId" + "}", encodeURIComponent(String(searchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(sendMessageRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新搜尋條件
         * @param {string} userId
         * @param {string} searchId
         * @param {UpdateSearchConditionRequest} updateSearchConditionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSearchCondition: function (userId, searchId, updateSearchConditionRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('updateSearchCondition', 'userId', userId);
                            // verify required parameter 'searchId' is not null or undefined
                            common_1.assertParamExists('updateSearchCondition', 'searchId', searchId);
                            // verify required parameter 'updateSearchConditionRequest' is not null or undefined
                            common_1.assertParamExists('updateSearchCondition', 'updateSearchConditionRequest', updateSearchConditionRequest);
                            localVarPath = "/api/user/{userId}/search/{searchId}/condition"
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)))
                                .replace("{" + "searchId" + "}", encodeURIComponent(String(searchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateSearchConditionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * SearchApi - functional programming interface
 * @export
 */
exports.SearchApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.SearchApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary 建立新搜尋(對話)
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewChat: function (userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createNewChat(userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 取得單一搜尋(對話)
         * @param {string} userId
         * @param {string} searchId
         * @param {QueryChatDetailRequest} [queryChatDetailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDetail: function (userId, searchId, queryChatDetailRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getChatDetail(userId, searchId, queryChatDetailRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 取得搜尋紀錄清單(對話列表)
         * @param {string} userId
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatList: function (userId, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getChatList(userId, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 中斷AI對話
         * @param {string} userId
         * @param {string} searchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interruptChat: function (userId, searchId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.interruptChat(userId, searchId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 發送新訊息
         * @param {string} userId
         * @param {string} searchId
         * @param {SendMessageRequest} sendMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: function (userId, searchId, sendMessageRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendMessage(userId, searchId, sendMessageRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 發送新訊息(SSE)
         * @param {string} userId
         * @param {string} searchId
         * @param {SendMessageRequest} sendMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageSSE: function (userId, searchId, sendMessageRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendMessageSSE(userId, searchId, sendMessageRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary 更新搜尋條件
         * @param {string} userId
         * @param {string} searchId
         * @param {UpdateSearchConditionRequest} updateSearchConditionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSearchCondition: function (userId, searchId, updateSearchConditionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSearchCondition(userId, searchId, updateSearchConditionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * SearchApi - factory interface
 * @export
 */
exports.SearchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.SearchApiFp(configuration);
    return {
        /**
         *
         * @summary 建立新搜尋(對話)
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewChat: function (userId, options) {
            return localVarFp.createNewChat(userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 取得單一搜尋(對話)
         * @param {string} userId
         * @param {string} searchId
         * @param {QueryChatDetailRequest} [queryChatDetailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDetail: function (userId, searchId, queryChatDetailRequest, options) {
            return localVarFp.getChatDetail(userId, searchId, queryChatDetailRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 取得搜尋紀錄清單(對話列表)
         * @param {string} userId
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatList: function (userId, page, size, options) {
            return localVarFp.getChatList(userId, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 中斷AI對話
         * @param {string} userId
         * @param {string} searchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        interruptChat: function (userId, searchId, options) {
            return localVarFp.interruptChat(userId, searchId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 發送新訊息
         * @param {string} userId
         * @param {string} searchId
         * @param {SendMessageRequest} sendMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: function (userId, searchId, sendMessageRequest, options) {
            return localVarFp.sendMessage(userId, searchId, sendMessageRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 發送新訊息(SSE)
         * @param {string} userId
         * @param {string} searchId
         * @param {SendMessageRequest} sendMessageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageSSE: function (userId, searchId, sendMessageRequest, options) {
            return localVarFp.sendMessageSSE(userId, searchId, sendMessageRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 更新搜尋條件
         * @param {string} userId
         * @param {string} searchId
         * @param {UpdateSearchConditionRequest} updateSearchConditionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSearchCondition: function (userId, searchId, updateSearchConditionRequest, options) {
            return localVarFp.updateSearchCondition(userId, searchId, updateSearchConditionRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
var SearchApi = /** @class */ (function (_super) {
    __extends(SearchApi, _super);
    function SearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 建立新搜尋(對話)
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.createNewChat = function (userId, options) {
        var _this = this;
        return exports.SearchApiFp(this.configuration).createNewChat(userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 取得單一搜尋(對話)
     * @param {string} userId
     * @param {string} searchId
     * @param {QueryChatDetailRequest} [queryChatDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.getChatDetail = function (userId, searchId, queryChatDetailRequest, options) {
        var _this = this;
        return exports.SearchApiFp(this.configuration).getChatDetail(userId, searchId, queryChatDetailRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 取得搜尋紀錄清單(對話列表)
     * @param {string} userId
     * @param {number} [page]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.getChatList = function (userId, page, size, options) {
        var _this = this;
        return exports.SearchApiFp(this.configuration).getChatList(userId, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 中斷AI對話
     * @param {string} userId
     * @param {string} searchId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.interruptChat = function (userId, searchId, options) {
        var _this = this;
        return exports.SearchApiFp(this.configuration).interruptChat(userId, searchId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 發送新訊息
     * @param {string} userId
     * @param {string} searchId
     * @param {SendMessageRequest} sendMessageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.sendMessage = function (userId, searchId, sendMessageRequest, options) {
        var _this = this;
        return exports.SearchApiFp(this.configuration).sendMessage(userId, searchId, sendMessageRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 發送新訊息(SSE)
     * @param {string} userId
     * @param {string} searchId
     * @param {SendMessageRequest} sendMessageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.sendMessageSSE = function (userId, searchId, sendMessageRequest, options) {
        var _this = this;
        return exports.SearchApiFp(this.configuration).sendMessageSSE(userId, searchId, sendMessageRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 更新搜尋條件
     * @param {string} userId
     * @param {string} searchId
     * @param {UpdateSearchConditionRequest} updateSearchConditionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.updateSearchCondition = function (userId, searchId, updateSearchConditionRequest, options) {
        var _this = this;
        return exports.SearchApiFp(this.configuration).updateSearchCondition(userId, searchId, updateSearchConditionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SearchApi;
}(base_1.BaseAPI));
exports.SearchApi = SearchApi;
